export default __webpack_public_path__ + "static/media/cart.cc347e41.svg";